import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { newsletterSignup } from "../lib/api";
import { HOME } from "../constants/testIds";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await newsletterSignup({ email, source: "footer" });
      toast.success("You're on the list. Welcome to ALTA.");
      setEmail("");
    } catch (err) {
      toast.error("Please try again with a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#2A1F1F] text-[#FDF3ED] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl">ALTA</span>
            <span className="font-mono text-[0.65rem] tracking-[0.32em] uppercase text-[#B89B66]">Recovery</span>
          </div>
          <p className="mt-6 max-w-sm text-[#E5C1AF] text-sm leading-relaxed">
            Curated recovery systems for cosmetic procedures — surgeon approved, spa considered, delivered before your surgery date.
          </p>
          <form onSubmit={submit} className="mt-8 flex max-w-sm border border-[#4A3535]">
            <input
              data-testid={HOME.newsletterInput}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 bg-transparent px-4 py-3 text-sm placeholder:text-[#A08D8D] focus:outline-none"
            />
            <button
              data-testid={HOME.newsletterSubmit}
              disabled={loading}
              className="bg-[#B89B66] text-[#2A1F1F] px-5 text-xs uppercase tracking-[0.2em] hover:bg-[#FDF3ED] transition-colors disabled:opacity-60"
            >
              {loading ? "…" : "Join"}
            </button>
          </form>
        </div>

        <div>
          <h4 className="font-mono text-[0.65rem] tracking-[0.32em] uppercase text-[#B89B66] mb-4">Shop</h4>
          <ul className="space-y-3 text-sm text-[#F0DFD0]">
            <li><Link to="/shop" className="hover:text-[#B89B66] transition-colors">All Systems</Link></li>
            <li><Link to="/refills" className="hover:text-[#B89B66] transition-colors">Refills</Link></li>
            <li><Link to="/finder" className="hover:text-[#B89B66] transition-colors">Procedure Finder</Link></li>
            <li><Link to="/products/liposuction" className="hover:text-[#B89B66] transition-colors">Liposuction</Link></li>
            <li><Link to="/products/breast_augmentation" className="hover:text-[#B89B66] transition-colors">Breast Augmentation</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-[0.65rem] tracking-[0.32em] uppercase text-[#B89B66] mb-4">Support</h4>
          <ul className="space-y-3 text-sm text-[#F0DFD0]">
            <li><Link to="/how-it-works" className="hover:text-[#B89B66] transition-colors">How It Works</Link></li>
            <li><Link to="/faq" className="hover:text-[#B89B66] transition-colors">FAQ</Link></li>
            <li><Link to="/faq" className="hover:text-[#B89B66] transition-colors">Shipping</Link></li>
            <li><Link to="/faq" className="hover:text-[#B89B66] transition-colors">Medical Disclaimer</Link></li>
            <li><Link to="/account/subscriptions" className="hover:text-[#B89B66] transition-colors">Manage Subscriptions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3A2A2A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col md:flex-row justify-between text-xs text-[#A08D8D]">
          <span>© {new Date().getFullYear()} ALTA Recovery. All rights reserved.</span>
          <span className="mt-2 md:mt-0">Not a medical device. Consult your surgeon for personalised advice.</span>
        </div>
      </div>
    </footer>
  );
}
